import { handleActions, combineActions } from 'redux-actions';
import { Zone, ZoneName } from '../../types/zones';
import { GruserSlice } from '../../types/store';
import {
  addModule,
  addModuleFail,
  addModuleSuccess,
  updateModuleOrderSuccess,
  updateLayoutVersion,
  fetchLayoutSuccess,
} from '../actions/layout';

const defaultState = {};

// merge-update zone state
const updateZoneState = (
  state: GruserSlice['layout'],
  zoneName: ZoneName,
  zoneStateSlice: Partial<Zone>
) => {
  return {
    ...state,
    zones: {
      ...(state?.zones || {}),
      [zoneName]: {
        ...(state?.zones?.[zoneName] || {}),
        ...zoneStateSlice,
      },
    },
  };
};

export default handleActions<any, any>(
  {
    [fetchLayoutSuccess.toString()]: (state, action) => ({
      ...state,
      ...action.payload,
    }),

    [updateLayoutVersion.toString()]: (state, action) => {
      const { version } = action.payload;
      return {
        ...state,
        version,
      };
    },

    [updateModuleOrderSuccess.toString()]: (
      state,
      action: ReturnType<typeof updateModuleOrderSuccess>
    ) => {
      const { zoneName, order: installedModulesIds } = action.payload;
      return updateZoneState(state, zoneName, {
        installedModulesIds,
      } as Partial<Zone>);
    },

    [addModule.toString()]: (state, action: ReturnType<typeof addModule>) => {
      const { payload } = action;
      if (!payload) {
        return;
      }
      const { zoneName, position } = payload;
      return updateZoneState(state, zoneName, {
        isInstallingModule: true,
        currentlyInstalledModulePostion: position,
      });
    },

    [combineActions(addModuleSuccess, addModuleFail).toString()]: (
      state,
      action: ReturnType<typeof addModuleSuccess>
    ) => {
      const { payload } = action;
      if (!payload) {
        return;
      }
      const { zoneName } = payload;
      return updateZoneState(state, zoneName, {
        isInstallingModule: false,
        currentlyInstalledModulePostion: undefined,
      });
    },
  },
  defaultState
);
